import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

import theme from './theme';

/**
 * Emotion style classes
 */
const footerBlock = css`
  background-color: ${theme.color.primaryBlack};
  background-image: linear-gradient(
    to bottom,
    ${theme.color.primaryDark},
    ${theme.color.primaryBlack}
  );
  padding: 1em 1.5em;

  a,
  div {
    color: ${theme.color.secondary};
  }

  a:hover,
  a:active {
    color: white;
  }
`;

const followMe = css`
  padding-right: 1em;
`;

const line = css`
  background: ${theme.color.primary};
  border: 0;
  height: 1px;
  margin: 0.5em 0;
`;

const referenceBlock = css`
  line-height: 2rem;
  word-spacing: 0.3em;

  a {
    border-bottom: 1px solid ${theme.color.highlight};
  }
`;

/**
 * Components
 */
const SocialIcons = ({ icons }) => (
  <>
    {icons.map(({ node }, idx) => (
      <a
        className="icon is-medium"
        href={node.url}
        key={idx}
        title={node.name}
      >
        <i className={`fab fa-${node.icon} fa-lg`} />
      </a>
    ))}
  </>
);

SocialIcons.propTypes = {
  icons: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const Footer = ({ icons }) => (
  <footer className={footerBlock}>
    <div className={theme.triangle}>
      <span className={followMe}>Follow me on</span>
      <SocialIcons icons={icons} />
    </div>

    <hr className={line} />

    <div className={`is-size-7 ${referenceBlock}`}>
      <span className="icon is-small">
        <i className="fa fa-code" />
      </span>
      {' '}with{' '}
      <span className="icon is-small">
        <i className="fa fa-heart" />
      </span>
      {' '}with{' '}
      <a href="https://www.gatsbyjs.org" title="Gatsby site generator">
        Gatsby
      </a>
    </div>
  </footer>
);

Footer.propTypes = {
  icons: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Footer;
